import { render, staticRenderFns } from "./TeamV2.vue?vue&type=template&id=07710a1a&scoped=true&"
import script from "./TeamV2.vue?vue&type=script&lang=js&"
export * from "./TeamV2.vue?vue&type=script&lang=js&"
import style0 from "./TeamV2.vue?vue&type=style&index=0&id=07710a1a&scoped=true&lang=scss&"
import style1 from "./TeamV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07710a1a",
  null
  
)

export default component.exports